import React, { useMemo } from 'react';
import { isMobile } from 'react-device-detect';

import { clearHtmlTags } from '@/helpers/HtmlHelper/clearHtmlTags';
import { getValue } from '@/helpers/GetValueHelper';

import { ICardProps } from './interface';

export const FixedCard = React.memo(({ data, onClick }: ICardProps) => {
  const { id, title, image } = data;
  const link = getValue(data, 'cta[0].link', '');

  const imageFormatted = useMemo(() => {
    let defaultImage = getValue(image, '[0].image.url', '') as string;
    if (image.length > 1 && isMobile) {
      const mobileImage = image.find(
        item => item.resolution.toLowerCase().indexOf('app') > -1,
      );
      defaultImage = mobileImage ? mobileImage.image.url : defaultImage;
    }
    return defaultImage;
  }, [image]);

  return (
    <a
      href={link}
      title={clearHtmlTags(title)}
      className="vitrine-template3__card vitrine-template3__card--fixed"
      key={id}
      data-id={id}
      onClick={e => onClick && onClick(e, id)}
    >
      <img
        className="vitrine-template3__card-image"
        src={imageFormatted}
        alt={clearHtmlTags(title)}
      />

      <span
        className="vitrine-template3__card-title"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: title }}
      />
    </a>
  );
});
